export const getSignificantDigitCount = (value: string) =>
  value.replace(/[^\d]/g, '').length;
